import { Container } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { useContext } from 'react';
import { Page } from 'components';
import { customerContext, customerSchema } from './CustomerContext';
import { CustomerForm } from './components';


let Customer = () => {
    let { isLoading, saveCustomer, customer } = useContext(customerContext);

    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                title="Customer"
                isLoading={isLoading}
            >
                <Formik
                    enableReinitialize={true}
                    validationSchema={customerSchema}
                    initialValues={customer}
                    onSubmit={(values, action) => {
                        saveCustomer(values as any);
                        action.setSubmitting(false);
                    }}
                >
                    <Form>
                        <CustomerForm />
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default Customer;